import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHorizontalBarsStacked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M62.824 36.597V79.15h84.545V36.597z"
      clipRule="evenodd"
    />
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M141.866 36.597V79.14h86.568c6.714 0 12.158-5.443 12.158-12.158V48.755c0-6.715-5.444-12.158-12.158-12.158z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M62.83 103.472v42.553h58.158v-42.553z"
      clipRule="evenodd"
    />
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M105.966 103.472v42.542h68.618c6.715 0 12.158-5.443 12.158-12.158V115.63c0-6.715-5.443-12.158-12.158-12.158z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M62.8 170.347V212.9h72.948v-42.553z"
      clipRule="evenodd"
    />
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M132.892 170.347v42.542h68.618c6.715 0 12.158-5.443 12.158-12.158v-18.226c0-6.715-5.443-12.158-12.158-12.158z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHorizontalBarsStacked;
